var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useImperativeHandle } from 'react';
import { useTreeEnvironment } from '../controlledEnvironment/ControlledTreeEnvironment';
import { useDragAndDrop } from '../controlledEnvironment/DragAndDropProvider';
export var useCreatedEnvironmentRef = function (ref, actions) {
    var environment = useTreeEnvironment();
    var dnd = useDragAndDrop();
    useImperativeHandle(ref, function () { return (__assign(__assign(__assign({}, actions), environment), { treeEnvironmentContext: environment, dragAndDropContext: dnd })); });
};
